import axios from 'axios';
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'DELETE_DATA_CENTER_SUCCESS', success}
}

function _error(error) {
    return {type: 'DELETE_DATA_CENTER_ERROR', error}
}

function _processing(processing) {
    return {type: 'DELETE_DATA_CENTER_PROCESSING', processing}
}

function deleteDataCenter(id) {
    return (dispatch) => {

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let config = {
            headers: {'Authorization': 'Bearer ' + loginToken()},
        };

        axios.delete(apiBaseUrl(`admin/datacenter/${id}`), config)

            .then(res => {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res);
            }).catch(error => {
            dispatch(_error(error));
            dispatch(_processing(false));
            handleError(error)

        });
    }
}

export default deleteDataCenter;